module.exports = __webpack_public_path__ + "static/media/petType-cat.a8b10ac3.jpg";